import _ from "lodash";

import { Notificator } from "../../../../components/notification";
import { getPreviewParams } from "../brandingForm/branding.selectors";
import {
  getInvalidValues,
  removeInvalidValues,
  trimValues,
} from "../../helpers/form.helper";
import { isFailure, ResourceName } from "@sportal/api";

export const loadWebContent =
  () =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
    } = getState();

    const result = await api.ssm.bpResources.getResource(
      id,
      ResourceName.WebContent
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("error_failed_to_load_data"));
      dispatch(generalFailure(result.error, LOAD_WEB_CONTENT_FAILURE));
      return;
    }

    dispatch(loadWebContentSuccess(result.data));
  };

export const changeWebContent =
  () =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
      resources: {
        webContent: { resource, validation, toSave },
      },
    } = getState();

    const newWebContent = trimValues(toSave);

    const updatedWebContent = _.defaults(newWebContent, resource),
      validatedWebContent = removeInvalidValues(updatedWebContent, validation),
      valuesToSave = getInvalidValues(newWebContent, validation);

    const result = await api.ssm.bpResources.updateResource(
      id,
      ResourceName.WebContent,
      validatedWebContent
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("couldnt_save_changes"));
      dispatch(generalFailure(result.error, CHANGE_WEB_CONTENT_FAILURE));
      return Promise.reject();
    }

    dispatch(changeWebContentSuccess(validatedWebContent, valuesToSave));
  };

export const getWebFilteringPreview =
  () =>
  async (dispatch, getState, { api }) => {
    const state = getState(),
      {
        subscriberInfo: { id },
        resources: { webContent },
      } = state;

    const { toSave: newWebContent, resource, validation } = webContent,
      updatedWebContent = _.defaults(newWebContent, resource),
      validatedWebContent = removeInvalidValues(updatedWebContent, validation),
      previewParams = getPreviewParams(validatedWebContent)(state);

    const result = await api.ssm.bpResources.getPreview(
      id,
      ResourceName.WebContent,
      previewParams
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("error_failed_to_load_data"));
      dispatch(generalFailure(result.error, LOAD_WEB_CONTENT_FAILURE));
      return Promise.reject();
    }

    localStorage.setItem("web-filtering", result.data);
  };

export const LOAD_WEB_CONTENT_SUCCESS =
  "[RESOURCES] [WEB_CONTENT] LOAD_WEB_CONTENT_SUCCESS";
export const LOAD_WEB_CONTENT_FAILURE =
  "[RESOURCES] [WEB_CONTENT] LOAD_WEB_CONTENT_FAILURE";
export const CHANGE_WEB_CONTENT_SUCCESS =
  "[RESOURCES] [WEB_CONTENT] CHANGE_WEB_CONTENT_SUCCESS";
export const CHANGE_WEB_CONTENT_FAILURE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_WEB_CONTENT_FAILURE";
export const CHANGE_ADMIN_EMAIL_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_ADMIN_EMAIL_TO_SAVE";
export const CHANGE_ADMIN_PHONE_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_ADMIN_PHONE_TO_SAVE";
export const CHANGE_MESSAGE_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_MESSAGE_TO_SAVE";
export const CHANGE_SHOW_CODE_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_SHOW_CODE_TO_SAVE";
export const CHANGE_SHOW_MESSAGE_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_SHOW_MESSAGE_TO_SAVE";
export const CHANGE_SHOW_NAME_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_SHOW_NAME_TO_SAVE";
export const RESET_TO_SAVE = "[RESOURCES] [WEB_CONTENT] RESET_TO_SAVE";

export const changeAdminEmailToSave = (adminEmail) => ({
  type: CHANGE_ADMIN_EMAIL_TO_SAVE,
  payload: adminEmail,
});
export const changeAdminPhoneToSave = (adminPhone) => ({
  type: CHANGE_ADMIN_PHONE_TO_SAVE,
  payload: adminPhone,
});
export const changeMessageToSave = (message) => ({
  type: CHANGE_MESSAGE_TO_SAVE,
  payload: message,
});
export const changeShowCodeToSave = () => ({
  type: CHANGE_SHOW_CODE_TO_SAVE,
});
export const changeShowMessageToSave = () => ({
  type: CHANGE_SHOW_MESSAGE_TO_SAVE,
});
export const changeShowNameToSave = () => ({
  type: CHANGE_SHOW_NAME_TO_SAVE,
});
export const loadWebContentSuccess = (webContent) => ({
  type: LOAD_WEB_CONTENT_SUCCESS,
  payload: webContent,
});
export const changeWebContentSuccess = (webContent, toSave) => ({
  type: CHANGE_WEB_CONTENT_SUCCESS,
  payload: { webContent, toSave },
});

export const resetToSave = () => ({
  type: RESET_TO_SAVE,
});
export const generalFailure = (error, type) => ({
  type,
  payload: error,
});
